














































































































































import { Component, Model, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import { CaseTaskFilter, CaseTasks } from "@/store/modules/types";
import InputPopover from "@/components/InputPopover.vue";

@Component({
  components: {
    BPagination,
    InputPopover,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cases", ["tasks"]),
  },
})
export default class TaskPager extends Vue {
  @Prop(Boolean) readonly rowsChecked!: Boolean;
  tasks!: CaseTasks;
  filterId = 0;
  filters = Array<any>();
  showSaveFilter = false;
  newFilterName = "";
  get selectedFilter() {
    return this.filters.find((f) => f.id === this.filterId);
  }
  @Watch("filterId")
  filterChanged() {
    if (this.selectedFilter) {
      const filter = JSON.parse(this.selectedFilter.json) as CaseTaskFilter;
      if (!filter.entityId) {
        filter.entityId = this.tasks.filter.entityId;
      }
      this.$store.commit("auth/SET_ENTITY", filter.entityId);
      this.$store.commit("cases/SET_CASE_TASKS_FILTER", filter);
    }
  }
  setPageNumber(page: number) {
    this.$store.commit("cases/SET_CASE_TASKS_PAGE_NUMBER", page);
  }
  setRowsPerPage(e) {
    const rowsPerPage: number = e.target.value;
    this.$store.commit("cases/SET_CASE_TASKS_ROWS_PER_PAGE", rowsPerPage);
  }
  async getFilters() {
    try {
      this.filters = await this.$store.dispatch("cases/getCaseTaskFilters");
      if (!this.tasks.pageRows.length) {
        this.filterChanged();
      }
    } catch (error) {
      console.log(error);
    }
  }
  async saveFilter(name: string) {
    try {
      const { newFilterId } = await this.$store.dispatch(
        "cases/saveCaseTaskFilter",
        name
      );
      this.filterId = newFilterId;
      this.getFilters();
    } catch (error) {
      console.log(error);
    }
  }
  async archiveFilter() {
    const { id, name } = this.selectedFilter;
    this.$modal.show("dialog", {
      title: "Remove filter '" + name + "'",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            try {
              await this.$store.dispatch("cases/archiveCaseTaskFilter", id);
              this.$modal.hide("dialog");
              this.filterId = 0;
              this.getFilters();
            } catch (error) {
              console.log(error);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  clearFilter() {
    if (this.filterId === 0) {
      this.$store.commit(
        "cases/RESET_CASE_TASKS_FILTER",
        this.tasks.filter.entityId
      );
    } else {
      this.filterId = 0;
    }
  }
  mounted() {
    this.getFilters();
  }
}
